module.exports = __webpack_public_path__ + "static/kosuthova-b4e42484b3222b61f27479d5d248d8db.jpg";